///////////////////////////////////////////////////////////////////////////////
//         Get the correct static path for Dev, Web and Electron App         //
///////////////////////////////////////////////////////////////////////////////
import path from 'path'
const get_static_path = file_path => {
  if (
    Object.keys(process.env).length < 20 &&
    !process.env.NODE_ENV === 'development'
  ) {
    return path.join(__dirname, '_public_', file_path)
  } else if (process.env.npm_package_TYPE === 'electron') {
    return `./_public_${file_path}`
  }
  return file_path
}

export default get_static_path
